/** Bookmarkable PM Equipment Configuration for a unit. */
export function pmEquipmentConfigurationPath(unitId: string): string {
    const id = unitId?.trim();
    if (!id) return '/pm-management';
    return `/pm-management/${encodeURIComponent(id)}`;
}
